import { Node_Type } from "./../ricos-schema/legacy/wix/rich_content/v1/index.js";
const fileUploadConverter = {
  toPm: {
    types: [Node_Type.FILE],
    // @ts-ignore $TSFixMe
    convert: (node) => ({
      type: Node_Type.FILE,
      attrs: {
        ...node.fileData,
        id: node.id
      }
    })
  },
  fromPm: {
    types: [Node_Type.FILE],
    convert: (node) => {
      const { id, loading, error, ...data } = node.attrs || {};
      if (loading || error) {
        return void 0;
      }
      return {
        type: Node_Type.FILE,
        id,
        nodes: [],
        fileData: {
          ...data
        }
      };
    }
  }
};
export {
  fileUploadConverter
};
//# sourceMappingURL=file-upload-converter.js.map
